<template>
  <div
    class="
      custom-group-tours-difference-card
      w-320
      br-12
      sd-4
      flex flex-column
      justify-top
      items-top
      overflow-hidden
    "
  >
    <div style='height: 250px;' class='overflow-hidden'>
      <img
        class="img-cover"
        :src="`${ASSETS_CDN}/images/${folderImg}/${data.src}.jpg`"
        :alt="data.title"
      />
    </div>
    <div class="content flex flex-column justify-center items-center tc pa-16">
      <h3 class="mb-8 fw-700 fs-20 lh-28" v-html="data.title"></h3>
      <p class="fw-500 fs-16 lh-22 ls-2 gray-dark mb-2">
        {{ data.content }}
      </p>
    </div>
  </div>
</template>

<script setup>
import {assetCDN} from '~/helper/index.js'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'
import { useRoute } from 'vue-router'

// eslint-disable-next-line no-undef
defineProps({
  data: {
    type: Object,
    default: () => {
      return {
        title: '',
        content: '',
        src: '',
      }
    },
  },
})
const ASSETS_CDN = assetCDN()
const route = useRoute()

const folderImg = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return "schooltourdetails"
  return "customgrouptour"
})
</script>

<style lang="scss" scoped>
.custom-group-tours-difference-card {
  border: 1px solid $border-hairline; // v2 single border (was #f1f1f1)
}
</style>
